import React, { useState, useEffect } from "react";
import { Box } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import SubscriptionPlanBadge from "./SubscriptionPlanBadge";
import CreditsBalanceBadge from "./CreditsBalanceBadge";
import FreeMessagesStatusBadge from "./FreeMessagesStatusBadge";
import UpgradeModal from "./UpgradeModal";
import useCreditsBalance from "../../hooks/useCreditsBalance";
import useFreeMessagesStatus from "../../hooks/useFreeMessagesStatus";
import useOnlineStatus from "../../hooks/useOnlineStatus";
import { useAppSelector } from "../../redux/typedHooks";
import { UserInterface } from "../../types/user";
import Cookies from "js-cookie";

const UserStatusWidget: React.FC = () => {
  const user = useAppSelector<UserInterface | null>(
    state => state.user.currentUser
  );
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const isOnline = useOnlineStatus();
  const location = useLocation();

  const {
    creditsRemaining,
    totalCredits,
    loading: creditsLoading,
    error: creditsError,
  } = useCreditsBalance();
  const {
    freeMessagesRemaining,
    freeMessagesLimit,
    isFreeQuotaExhausted,
    loading: freeMessagesLoading,
  } = useFreeMessagesStatus();

  // Check if user is Creator
  const isCreator = user?.userType?.title === "creator" || 
    user?.userType?._id === "6800a63485ec077c7c266c25";

  // Don't show upgrade modal automatically when credits = 0
  // Modal will only be shown when Viewer tries to send a direct message with 0 credits
  useEffect(() => {
    // Never show modal automatically - only show when Viewer tries to send message
    setShowUpgradeModal(false);
  }, [totalCredits, creditsLoading, creditsError, user, isOnline, location.pathname]);

  const handleCloseUpgradeModal = () => {
    setShowUpgradeModal(false);
  };

  return (
    <>
      <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {/* Subscription Plan Badge */}
        {/* <SubscriptionPlanBadge /> */}

        {/* Credits Balance Badge - Always visible */}
        <CreditsBalanceBadge />

        {/* Free Messages Status Badge - Only for viewers */}
        {/* <FreeMessagesStatusBadge /> */}
      </Box>

      {/* Upgrade Modal */}
      <UpgradeModal
        isOpen={showUpgradeModal && !creditsLoading}
        onClose={handleCloseUpgradeModal}
        creditsRemaining={creditsRemaining}
        freeMessagesRemaining={freeMessagesRemaining}
        freeMessagesLimit={freeMessagesLimit}
      />
    </>
  );
};

export default UserStatusWidget;
